<template>
  <div style="overflow-x: hidden">
    <div>
      <v-layout wrap>
        <v-flex
          xs6
          sm6
          md10
        >
          <h4 class="cus-panel-title" style=" margin-bottom: 0px">
            ADD SHIP ONLY</h4>
        </v-flex>
      </v-layout>
    </div>

    <div
      class="col-md-12 cus-orange-light"
      style="margin-top: 10px ; border-top-style: solid; border-width: 2px;"
    >
      <div
        style="display: none"
        id="ware"
      >
      </div>
    </div>

    <form @submit.prevent="submitForm()">
      <v-card-text style="padding-top: 0px">
        <v-alert
          type="success"
          :value="isDone"
        >
          Ordered successfully
        </v-alert>
        <v-container grid-list-md>
          <div class="row">

            <div class="col-md-6">
              <v-select
                :items="warehouses"
                item-value="value"
                v-model="form.warehouse_id_fk"
                :error-messages="errors.collect('Warehouse')"
                data-vv-name="Warehouse"
                label="Warehouse*"
                v-validate="'required'"
                @input="handleSelectWarehouse(form.warehouse_id_fk)"
              >
              </v-select>
            </div>

            <div class="col-md-6">
              <v-select
                :items="transportationTypes"
                item-value="id"
                item-text="name"
                v-model="form.transportation_type"
                :error-messages="errors.collect('Transportation Type')"
                data-vv-name="Transportation Type"
                label="Transportation Type*"
                v-validate="'required'"
                @input="getOurAddresses"
              >
              </v-select>
            </div>

            <div class="col-md-12" v-if="form.transportation_type">
              <v-flex
            xs12
            sm12
            md12
            v-for="address in ourAddresses"
            :key="address.our_address_id"
            class="pa-2"
          >
            <div class="note-card-description">
              <div><strong>Note:</strong></div>
              {{ address.note }}
            </div>
            <div class="address-card">
              <div class="address-card-title d-flex">
                {{ address.title }}
                <div style="text-align: right">
                  <i
                    v-if="address.showCopyIcon"
                    class="fa fa-copy"
                    style="font-size: 16px; color: #F57C00; cursor: pointer;"
                    @click="copyDescription(address)"
                  />

                  <span
                    v-else
                    style="font-weight: normal; font-size: 14px"
                  >
                    <i
                      class="fa fa-check"
                      style="font-size: 14px;"
                    ></i>
                    Copied
                  </span>
                </div>
              </div>
              <div class="address-card-description" v-html="addCustomerCode(address.description)"></div>
            </div>
          </v-flex>
            </div>
          </div>
        </v-container>
      </v-card-text>
      <!-- <div class="col-sm-4 col-md-3 col-md-offset-8 submit-padding">
        <v-btn
          type="submit"
          :loading="loading"
          style="width: 95%; height:auto; margin-bottom: 3%"
          class="cus-custom-warning"
        >Add</v-btn>
      </div> -->
    </form>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  mounted() {
    this.getLoggedInUser()
    this.getWarehouses()
    this.getWarehousesToSelect()
    this.getOurAddresses()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      transportationTypes: [],
      loggedInUserData: {},
      loading: false,
      form: {
        transportation_type: null
      },
      warehouses: [],
      ourAddresses: [],
      isDone: false,
      x: 1,
      usaWarehouse: {}
    }
  },

  methods: {
    handleSelectWarehouse(id) {
      this.form.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
      }

      this.getOurAddresses()
    },

    addCustomerCode(description, bold = true) {
      if (!description) return ''
      const userId = this.loggedInUserData.user_id || ''
      const customerInfo = bold ? `<strong>${userId}</strong>` : userId
      const withCustomer = description.replace(/Customer/gi, customerInfo)
      return withCustomer.replace(/\r?\n/g, '<br>')
    },

    getOurAddresses() {
      let token = localStorage.getItem('access_token')

      // Build query parameters
      let params = {}
      if (this.form.warehouse_id_fk) {
        params.warehouse_id_fk = this.form.warehouse_id_fk
      }
      if (this.form.transportation_type) {
        params.transportation_type = this.form.transportation_type
      }

      axios
        .get('api/our-address/list', {
          headers: { Authorization: 'Bearer ' + token },
          params: params
        })
        .then(res => {
          this.ourAddresses = res.data.map(d => {
            d.showCopyIcon = true
            return d
          })
        })
    },

    copyDescription(address) {
      address.showCopyIcon = false
      navigator.clipboard.writeText(this.addCustomerCode(address.description, false))

      setTimeout(() => {
        address.showCopyIcon = true
      }, 1500)
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.usaWarehouse = response.data.data[0]
        })
    },

    showWarehouseSection() {
      if (this.x === 1) {
        this.x = 2
        $('#ware').show('slow')
      } else if (this.x === 2) {
        this.x = 1
        $('#ware').hide('slow')
      }
    },

    removeSpaces() {
      this.form.track_number = this.form.track_number.replaceAll(/\s+/g, '')
    },

    getWarehousesToSelect() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    closeDialog() {
      this.$validator.reset()
      this.form = {}
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          axios
            .post('api/customer/store_ship_only_order', this.form, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.isDone = true
              this.form = {}
              setTimeout(() => {
                this.isDone = false
              }, 2000)
            })
        }
      })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    }
  }
}
</script>

<style scoped>
.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.panel-flat {
  overflow-x: hidden !important;
}

.address-card {
  background-color: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  padding: 12px;
}

.address-card-title {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 8px;
}

.address-card-description {
  white-space: pre-line;
}

.note-card-description {
  background-color: #f7f9fc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  color: #334155;
  white-space: pre-line;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
}
</style>



// WEBPACK FOOTER //
// src/components/customer/newShipOnly.vue